import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	form__params: 'mw/form/params',
	form__values__search: 'mw/form/values/search',
};

export const formApi = createApi({
	reducerPath: 'mw/formApi',

	endpoints: (builder) => ({
		formParams: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/form/params?${qs.stringify(body)}`,
			}),
			providesTags: [tags.form__params],
		}),
		formValuesSearch: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/form/values/search',
				body,
			}),
			providesTags: [tags.form__params],
		}),
	}),
});

export const {
	formParams,
	formValuesSearch,
} = formApi.endpoints;

export default formApi;